class ConfirmDialogController {
  constructor() {
    "ngInject";

    let vm = this;
    vm.name = 'confirmDialog';
  }
}

export default ConfirmDialogController;



// WEBPACK FOOTER //
// ./client/app/common/confirmDialog/confirmDialog.controller.js